const PermissionDenied = ({ show }) => {
  return (
    <div className={show === true ? `card my-5` : `card my-5 d-none`}>
      {/*begin::Card body*/}
      <div className="card-body text-center py-5">
        <img
          style={{ width: "150px" }}
          className="mt-5 mb-3"
          src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/auth/access-denied.png`}
          alt="Access Denied"
        />
        <p
          style={{ width: "150px" }}
          className="h6 text-bolder text-white bg-danger mb-5 mx-auto py-3"
        >
          <i>Access Denied</i>
        </p>
      </div>
      {/*end::Card body*/}
    </div>
  );
};

export default PermissionDenied;
